import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import MapContainer from '../Map/Map.container';
import DeviceSettingsContainer from '../Device-settings/Device-settings.container';
import EditDeviceContainer from '../Edit-device/Edit-device.container';
import DeviceInfoContainer from '../Device-info/Device-info.container';
import AddDeviceMainContainer from '../Add-device/Add-device-main.container';
import AddDeviceInDbMainContainer from '../Add-device-in-db/Add-device-in-db-main.container';
import { windows } from '@store/App.store';

const Container = () => {
    const { app } = useStore();
    const onDeviceSettingsClose = () => {
        app.closeDeviceSettings();
    };
    const onEditDeviceClose = () => {
        app.closeDeviceEdit();
    };
    const onDeviceInfoClose = () => {
        app.closeDeviceInfo();
    };
    const onAddDeviceClose = () => {
        app.closeAddDevice();
    };
    const onAddDeviceInDbClose = () => {
        app.closeAddDeviceInDb();
    };    
           
    switch (app.mainWindow) {
        case windows.deviceSettings:
            return (
                <>
                    <DeviceSettingsContainer onClose={onDeviceSettingsClose} />
                </>
            );
        case windows.deviceEdit:
            return (
                <>
                    <EditDeviceContainer onClose={onEditDeviceClose} />
                </>
            );
        case windows.deviceInfo:            
            return (
                <>                    
                    <DeviceInfoContainer onClose={onDeviceInfoClose} />
                </>
            );
        case windows.addDevice:
            return (
                <>
                    <AddDeviceMainContainer onClose={onAddDeviceClose} />
                </>
            );
        case windows.addDeviceInDb:
            return (
                <>                    
                    <AddDeviceInDbMainContainer
                        onClose={onAddDeviceInDbClose}
                    />
                </>
            );
        default:
            return (
                <>                                  
                    <MapContainer />
                </>
            );
    }
};

const MainContainer = observer(Container);

export default MainContainer;
